export default {
	tabs: ["Einzahlung", "Verlauf"],
	History: {
		tabs: ["Überprüfung", "Erfolg", "Ablehnen"]
	},
	AccountAmount: "Kontobetrag",
	ContactCustomerService: "Kundenservice Kontaktieren",
	NoCustomerService: "Kundenservice Besetzt",
	tips: "Bitte reichen Sie die vorherige Bewertung ein, bevor Sie mit der nächsten Bewertung fortfahren!"
};
